export function extractVariablesFromContent(html: string): string[] {
  const textContent = html.replace(/<[^>]*>/g, '');
  const regex = /\{\{([^}]+)\}\}/g;
  const matches = new Set<string>();
  let match;

  while ((match = regex.exec(textContent)) !== null) {
    matches.add(match[1].trim());
  }

  return Array.from(matches);
}
